import { mergeStyles } from '@fluentui/react';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import React from 'react';

interface ILinkOpenNewTabDescriptionProps {
  readonly id: string;
}

export const LinkOpenNewTabDescription: React.FC<ILinkOpenNewTabDescriptionProps> = ({ id }) => {
  const [t] = useLocalization('Account');
  // This style setting makes the element visually hidden but screen reader can read the content.
  const className = mergeStyles({
    position: 'absolute',
    width: 1,
    clip: 'rect(0 0 0 0)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  });

  return (
    <p className={className} id={id}>
      {t('openInNewTab')}
    </p>
  );
};
